import { mergeModels, useModel, ref, watch, nextTick, resolveComponent, createBlock, openBlock, unref, normalizeClass, withCtx, createElementBlock, renderSlot, createCommentVNode, Fragment, renderList, createElementVNode, toDisplayString, mergeProps, createVNode } from "vue";
import { Container, Draggable } from "vue-dndrop";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "../../plugins/apollo.js";
import "lodash-es";
import "moment";
import { applyDrag } from "../../utils/helpers.js";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import { useI18n } from "../../plugins/i18n.js";
import "../../assets/e94e4817134d7c25.png";
import "../../assets/5341da3ffbec0137.png";
import "../../assets/01f50022317dccd7.png";
import "axios";
import "vue-router";
import "maska";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
import "../../graphql/system-settings.js";
import "../../graphql/session-store.js";
import "vee-validate";
import "../../composables/useModalPage.js";
import "tiny-emitter/instance";
import "@iconify/vue";
import "../../icons/mdi/index.js";
import "../../icons/portal/index.js";
import "../../graphql/mutations.js";
import "graphql-tag";
import "../../graphql/entity.js";
import "../../graphql/lookups.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import EmptyData from "../Base/EmptyData.vue.js";
import "../../graphql/navigation-menu.js";
import { NavigationMenu } from "../../constants/NavigationMenu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
/* empty css                               */
import "vuetify/components/VGrid";
import "../Base/index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                      */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                        */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
/* empty css                             */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                            */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                                             */
/* empty css                          */
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css                     */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                         */
import "vuetify/components/VTooltip";
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
/* empty css                            */
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
/* empty css                            */
/* empty css                    */
import "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
/* empty css                        */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                               */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                  */
import "vuetify/components/VItemGroup";
/* empty css                             */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                        */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
const _hoisted_1 = ["onClick"];
const _sfc_main = {
  __name: "RecursiveDraggableMenu",
  props: /* @__PURE__ */ mergeModels({
    isRoot: {
      type: Boolean
    },
    groupName: {
      type: String
    }
  }, {
    "items": {},
    "itemsModifiers": {},
    "selectedItem": {},
    "selectedItemModifiers": {}
  }),
  emits: ["update:items", "update:selectedItem"],
  setup(__props) {
    const { bt } = useI18n();
    const items = useModel(__props, "items");
    const selectedItem = useModel(__props, "selectedItem");
    const containerRef = ref(null);
    const selectItem = (item) => {
      selectedItem.value = item;
    };
    const onDrop = (dropResult) => {
      items.value = applyDrag(items.value ?? [], dropResult);
    };
    const getItemName = (item) => {
      return item.name ? bt(item.name).trim() : "--";
    };
    const getGhostParent = () => {
      if (!containerRef.value) {
        return null;
      }
      let parent = containerRef.value.$el.closest(".b-draggable-menu");
      while (parent == null ? void 0 : parent.parentElement) {
        const higherParent = parent.parentElement.closest(".b-draggable-menu");
        if (!higherParent) {
          break;
        }
        parent = higherParent;
      }
      return parent;
    };
    const scrollToSelectedItem = () => {
      if (containerRef.value && selectedItem.value) {
        const selectedItemEl = containerRef.value.$el.querySelector(".selected-item");
        if (selectedItemEl) {
          containerRef.value.$el.scrollTo({
            top: selectedItemEl.offsetTop,
            behavior: "smooth"
          });
        }
      }
    };
    watch(selectedItem, async () => {
      await nextTick();
      scrollToSelectedItem();
    });
    return (_ctx, _cache) => {
      const _component_b_icon = resolveComponent("b-icon");
      const _component_RecursiveDraggableMenu = resolveComponent("RecursiveDraggableMenu", true);
      return openBlock(), createBlock(unref(Container), {
        ref_key: "containerRef",
        ref: containerRef,
        class: normalizeClass("b-draggable-menu"),
        "group-name": __props.groupName,
        "get-child-payload": (i) => items.value[i],
        "get-ghost-parent": getGhostParent,
        "lock-axis": "y",
        onDrop: _cache[1] || (_cache[1] = ($event) => onDrop($event))
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(items.value, (item, i) => {
            return openBlock(), createBlock(unref(Draggable), {
              "drag-not-allowed": item.id === unref(NavigationMenu).Favorite
            }, {
              default: withCtx(() => {
                var _a, _b;
                return [
                  createElementVNode("div", {
                    class: normalizeClass([
                      "b-draggable-item d-flex flex-column g-2",
                      { "fixed-item": item.id === unref(NavigationMenu).Favorite },
                      { "deleted-item": item.isDeleted || item.isHidden },
                      { "selected-item": item.id === ((_a = selectedItem.value) == null ? void 0 : _a.id) }
                    ])
                  }, [
                    createElementVNode("div", {
                      class: normalizeClass([
                        "d-flex flex-nowrap g-2 align-center",
                        { "subtitle-item": __props.isRoot }
                      ]),
                      onClick: ($event) => selectItem(item)
                    }, [
                      item.id === unref(NavigationMenu).Favorite ? (openBlock(), createBlock(_component_b_icon, {
                        key: 0,
                        class: normalizeClass("pin-icon"),
                        icon: "mdi-pin",
                        size: 16
                      })) : createCommentVNode("", true),
                      item.icon ? (openBlock(), createBlock(_component_b_icon, {
                        key: 1,
                        icon: item.icon
                      }, null, 8, ["icon"])) : createCommentVNode("", true),
                      createElementVNode("span", null, toDisplayString(getItemName(item)), 1),
                      item.isDeleted || item.isHidden ? (openBlock(), createBlock(_component_b_icon, {
                        key: 2,
                        icon: "mdi-eye-off",
                        size: 16
                      })) : createCommentVNode("", true),
                      renderSlot(_ctx.$slots, "actions", { item }, void 0, true)
                    ], 10, _hoisted_1),
                    item.isGroup && item.id !== unref(NavigationMenu).Favorite ? (openBlock(), createBlock(_component_RecursiveDraggableMenu, mergeProps({
                      key: 0,
                      class: !((_b = item.children) == null ? void 0 : _b.length) ? "empty-draggable-area" : "",
                      "group-name": __props.groupName,
                      "selected-item": selectedItem.value,
                      "onUpdate:selectedItem": _cache[0] || (_cache[0] = ($event) => selectedItem.value = $event),
                      items: item.children,
                      "onUpdate:items": ($event) => item.children = $event
                    }, { ref_for: true }, _ctx.$slots), null, 16, ["class", "group-name", "selected-item", "items", "onUpdate:items"])) : createCommentVNode("", true)
                  ], 2)
                ];
              }),
              _: 2
            }, 1032, ["drag-not-allowed"]);
          }), 256)),
          __props.isRoot && !items.value.length ? renderSlot(_ctx.$slots, "empty", { key: 0 }, () => [
            createVNode(unref(EmptyData), {
              class: "pa-3",
              width: 120
            })
          ], true) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["group-name", "get-child-payload"]);
    };
  }
};
const RecursiveDraggableMenu = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-1af23c6f"]]);
export {
  RecursiveDraggableMenu as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
